<template>
    <backend-layout title="Campaigns" :navs="navs">
        <div class="grid gap-6 grid-cols-1 md:grid-cols-3 mb-6 mt-6">
<!--            <div class="md:rounded border-gray-100 dark:bg-gray-900/70 bg-white border dark:border-gray-800">-->
<!--                <div class="card-content">-->
<!--                    <div class="flex items-center justify-between">-->
<!--                        <div class="widget-label">-->
<!--                            <h3>-->
<!--                                Referral Links-->
<!--                            </h3>-->
<!--                            <h1>-->
<!--                                {{ referrers }}-->
<!--                            </h1>-->
<!--                        </div>-->
<!--                        <span class="icon widget-icon text-blue-500"><i class="mdi mdi-link mdi-48px"></i></span>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

            <div class="md:rounded border-gray-100 dark:bg-gray-900/70 bg-white border dark:border-gray-800">
                <div class="card-content">
                    <div class="flex items-center justify-between">
                        <div class="widget-label">
                            <h3>
                                Total Visits
                            </h3>
                            <h1>
                                {{ clicks }}
                            </h1>
                        </div>
                        <span class="icon widget-icon text-red-500"><i
                            class="mdi mdi-cursor-pointer mdi-48px"></i></span>
                    </div>
                </div>
            </div>

            <div class="md:rounded border-gray-100 dark:bg-gray-900/70 bg-white border dark:border-gray-800">
                <div class="card-content">
                    <div class="flex items-center justify-between">
                        <div class="widget-label">
                            <h3>
                                Assigned Influencers
                            </h3>
                            <h1>
                                {{ referrers }}
                            </h1>
                        </div>
                        <span class="icon widget-icon text-blue-500"><i
                            class="mdi mdi-account-group mdi-48px"></i></span>
                    </div>
                </div>
            </div>

        </div>

        <section
            class="py-6">
            <div class="flex justify-between items-center block md:flex">
                <div class="flex shrink-0 grow-0 items-center justify-center mb-6 md:mb-0">
                    <h1
                        class="text-3xl font-semibold leading-tight">
                    </h1>
                </div>
                <period-toggle-segment :range="range" @change-range-value="(value) => range = value"></period-toggle-segment>
            </div>
        </section>

        <div class="grid gap-4 grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 mb-6">

            <clicks-graph :range="range" :campaign-code="campaign.code"></clicks-graph>

            <locations-graph :range="range" :campaign-code="campaign.code"></locations-graph>

            <browsers-graph :range="range" :campaign-code="campaign.code"></browsers-graph>

            <platforms-graph :range="range" :campaign-code="campaign.code"></platforms-graph>

            <devices-graph :range="range" :campaign-code="campaign.code"></devices-graph>

            <sources-graph :range="range" :campaign-code="campaign.code"></sources-graph>

            <referrers-graph :range="range" :campaign-code="campaign.code"></referrers-graph>

        </div>
    </backend-layout>
</template>

<script>
import BackendLayout from "@/Layouts/BackendLayout";
import ClicksGraph from "@/Components/Widgets/ClicksGraph";
import LocationsGraph from "@/Components/Widgets/LocationsGraph";
import BrowsersGraph from "@/Components/Widgets/BrowsersGraph";
import PlatformsGraph from "@/Components/Widgets/PlatformsGraph";
import DevicesGraph from "@/Components/Widgets/DevicesGraph";
import SourcesGraph from "@/Components/Widgets/SourcesGraph";
import ReferrersGraph from "@/Components/Widgets/ReferrersGraph";
import {ref} from "vue";
import PeriodToggleSegment from "@/Components/PeriodToggleSegment";

export default {
    name: "Analytics",
    props: {
        campaign: Object,
        clicks: String,
        referrers: String
    },
    components: {
        PeriodToggleSegment,
        ReferrersGraph,
        SourcesGraph, DevicesGraph, PlatformsGraph, BrowsersGraph, LocationsGraph, ClicksGraph, BackendLayout},
    setup(props){
        const navs = [{title: 'Analytics'},{title: props.campaign.name}];
        let range = ref("monthly");

        return{
            navs,
            range
        }
    }
}
</script>

<style scoped>

</style>
